import { trans } from '../translation';
import eventBus from './event-bus';

const flashBag = (type, message) => {
  eventBus.dispatchEvent(
    new CustomEvent('flashbags-push', {
      detail: {
        [type]: [ message ],
      },
    }),
  );
};

const flashBagSuccess = (message) => {
  flashBag('success', message);
};

const flashBagError = (message) => {
  if (message) {
    flashBag('error', message);
    return;
  }
  flashBag('error', trans('global.error'));
};

export { flashBag, flashBagSuccess, flashBagError };
